/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

const moduleName = 'ajs-legacy';
const componentName = 'match';
const prefix = `${moduleName}.${componentName}`;

export const clientIpLabel = `${prefix}.clientIpLabel`;
export const portMatchLabel = `${prefix}.portMatchLabel`;

export const ENGLISH = {
    [clientIpLabel]: 'Client IP',
    [portMatchLabel]: 'Port Match',
};
